// extracted by mini-css-extract-plugin
export default {"modal-survey-template-list":"ModalSurveyTemplate_modal-survey-template-list__0-VC1","modal-survey-template-search":"ModalSurveyTemplate_modal-survey-template-search__d4WmV"};